import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getItemsModel = createSelector(getModel, (model) => model.items);

export const getItemsData = createSelector(
    getItemsModel,
    (model) => model.data.data || [],
);

export const getItemsErrors = createSelector(
    getItemsModel,
    (model) => model.errors,
);

export const getItemsIsFetching = createSelector(
    getItemsModel,
    (model) => model.isFetching,
);

export const getItemsPagination = createSelector(
    getItemsModel,
    (model) => model.data.pagination || {},
);

export const getBulkUpdateItemsModel = createSelector(
    getModel,
    (model) => model.bulkUpdateItems,
);

export const getIsFetchingBulk = createSelector(
    getBulkUpdateItemsModel,
    (model) => model.isFetching,
);

export const getDuplicateModel = createSelector(
    getModel,
    (model) => model.duplicateProduct,
);

export const getIsDuplicatingItem = createSelector(
    getDuplicateModel,
    (model) => model.isDuplicating,
);

export const getIsOpenProductForm = createSelector(
    getModel,
    (model) => model.isOpenProductForm || false,
);

export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);

export const getSave = createSelector(getModel, (model) => model.save);

export const getIsSaving = createSelector(getSave, (save) => save.isSaving);

export const getDataSave = createSelector(getSave, (save) => save.data);

export const getErrorsSave = createSelector(getSave, (save) => save.errors);

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getValues = createSelector(
    (state) => getFormValues(`${NAME}/form`)(state),
    (values) => values || {},
);

export const getItemDetail = createSelector(
    getModel,
    (model) => model.itemDetail,
);

export const getIsFetchingItemDetail = createSelector(
    getItemDetail,
    (model) => model.isFetching,
);

export const getFilters = createSelector(getModel, (model) => model.filters);

export const getEnabledEdition = createSelector(
    getModel,
    (model) => model.isEnabledEdition,
);
